<template>
<div class="chapter">
<div class="inner_page">
<p class="content1">C<span class="small">ONTENTS</span></p>
<p class="con1" id="rfor"><a href="#/foreword#for">Foreword</a></p>
<p class="con2" id="rpre"><a href="#/preface#pre">Preface</a></p>
<p class="con1" id="rChap01"><a href="#/chapter01#Chap01">True Learning</a></p>
<p class="con" id="rChap02"><a href="#/chapter02#Chap02">A Little Learning</a></p>
<p class="con" id="rChap03"><span href="#/chapter03#Chap03" title="Link target outside of Sample">Schools Are Bad Places for Kids</span></p>
<p class="con" id="rChap04"><span href="#/chapter04#Chap04" title="Link target outside of Sample">The Fourth R: The Rat Race</span></p>
<p class="con" id="rChap05"><span href="#/chapter05#Chap05" title="Link target outside of Sample">Teachers Talk Too Much</span></p>
<p class="con" id="rChap06"><span href="#/chapter06#Chap06" title="Link target outside of Sample">The Tyranny of Testing</span></p>
<p class="con" id="rChap07"><span href="#/chapter07#Chap07" title="Link target outside of Sample">Not So Golden Rule Days</span></p>
<p class="con" id="rChap08"><span href="#/chapter08#Chap08" title="Link target outside of Sample">Making Children Hate Reading</span></p>
<p class="con" id="rChap09"><span href="#/chapter09#Chap09" title="Link target outside of Sample">Order and Disorder</span></p>
<p class="con" id="rChap10"><span href="#/chapter10#Chap10" title="Link target outside of Sample">Teaching the Unteachable</span></p>
<p class="con" id="rChap11"><span href="#/chapter11#Chap11" title="Link target outside of Sample">Education for the Future</span></p>
<p class="con" id="rChap12"><span href="#/chapter12#Chap12" title="Link target outside of Sample">Blackboard Bungle</span></p>
<p class="con" id="rChap13"><span href="#/chapter13#Chap13" title="Link target outside of Sample">Children in Prison</span></p>
<p class="con" id="rChap14"><span href="#/chapter14#Chap14" title="Link target outside of Sample">Comic Truth on an Urgent Problem</span></p>
<p class="con" id="rChap15"><span href="#/chapter15#Chap15" title="Link target outside of Sample">Talk</span></p>
<p class="con" id="rChap16"><span href="#/chapter16#Chap16" title="Link target outside of Sample">Letter</span></p>
<p class="con1" id="rChap17"><span href="#/chapter17#Chap17" title="Link target outside of Sample">Bibliography</span></p>
<p class="con" id="rChap18"><span href="#/chapter18#Chap18" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="con" id="rChap19"><span href="#/AbouttheAuthor#Chap19" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2c76eb44